<template>
  <div class="cursossection">
    <FilterHeader
        v-if="showFilter"
        @selectedfilter="filterCiclo"
        :faculdadename="$store.state.faculdadename"
        :ciclos="ciclos"
        :current-ciclo="ciclo" />
    <div class="row align-center">
      <div class="small-10 medium-10 large-11 columns">
        <SimpleFilterHeader
            v-if="showFilter"
            :is-up="showFilters"
            :value="$translate('UMA_LANG_FACULDADE_FILTRARPOR')"
            @click="showFilters = !showFilters"
            class="filter_mobile"/>
        <Combobox
            v-if="showFilter"
            class="combomobile"
            :disablenull="true"
            :caretend="true"
            @clickOutside="closeCombo"
            defaultmsg="Selecione uma das opções"
            @update:openCombo="toogleCombo"
            @update:closeCombo="closeCombo"
            :isOpen="openCiclo"
            :options="ciclos"
            v-model="ciclo" />
        <div class="cursonewcontainer"
             :class="{'nomargin': !showFilter}">
            <FaculdadeCurso
                :key="item.nome"
                :nome="item.nome"
                :url="item.url"
                v-for="item in cursosForGrau"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Combobox } from "umaui";
import constants  from "../../constants.js";
import FilterHeader from "../../components/FilterHeader.vue";
import SimpleFilterHeader from "../../components/SimpleFilterHeader.vue";
import FaculdadeCurso from "../../components/FaculdadeCurso.vue";
import axios from "../../axios.js";

export default {
  name: "CursoGrid",
  inject:["id","i18n","language"],
  components:{
    FaculdadeCurso,
    FilterHeader,
    SimpleFilterHeader,
    Combobox
  },
  data(){
    return{
      ciclos:[ ],
      ciclo: "",
      cursoList:[ ],
      showFilters: false,
      openCiclo: false,
      ciclosslug:{
        "1ciclo": "1o-ciclo",
        "2ciclo": "2o-ciclo",
        "3ciclo": "3o-ciclo",
        "ctesp": "ctesp",
        "posgraduacao": "pos-graduacoes",
        "preparatorio": "curso-preparatorio",
        "preparatório": "curso-preparatorio",
        "livre": "cursos-livres"
      }
    }
  },
  created() {
    this.getGrausForFaculdade();
    this.getCursos();
  },
  computed:{
    showFilter(){
      return this.cursoList.length > constants.minNumberCourses;
    },
    cursosForGrau(){
      if(this.showFilter && this.ciclo.value != ""){
        const filteredList = this.cursoList.filter(el => {
          return el.ciclo == this.ciclo.value
        });
        return filteredList;
      }
      return this.cursoList;
    }
  },
  methods:{
    toogleCombo(){
      this.openCiclo = !this.openCiclo;
    },
    closeCombo(){
      this.openCiclo = false;
    },
    filterAndShow(ciclo){
      this.showFilters = false;
      this.filterCiclo(ciclo);
    },
    getGrausForFaculdade(){
      axios.get(`/faculdades/${this.id}/graus?idioma=${this.language}`).
      then(data => {
        const graus = data.data;
        for (const key in graus) {
          const newCiclo = {
            "label": key == "preparatório" || key == "livre" ? this.$translate("UMA_LANG_OUTROSCURSOS") : graus[key],
            "value": key == "preparatório" || key == "livre" ? 'outros' : key
          }
          this.ciclos.push(newCiclo)
        }
        this.ciclos.sort((a,b) => {
          if(a.value == "ctesp"){
            return -1
          }
          if(b.value == "ctesp"){
            return 1
          }
        });
        this.ciclo = this.ciclos[0];
      }).catch(error => {
        console.log(error);
      })
    },
    getCursos(){
      axios.
      get(`/faculdades/${this.id}/cursos?idioma=${this.language}`).
      then(data => {
        const l = this.language == "pt" ? "/" : "en/";
        this.cursoList = data.data.map(el =>{
          var updatedCiclo = el.ciclo;
          if(el.ciclo == "preparatorio" || el.ciclo == "preparatório" || el.ciclo == "livre"){
            updatedCiclo = 'outros'
          }
          return {
            'nome': el.post_title,
            "url": `${import.meta.env.VITE_APP_SITE_URL}${l}ensino/${this.ciclosslug[el.ciclo]}/${el.slug}`,
            "ciclo": updatedCiclo
          }
        });
      }).
      catch(error => {
        console.log(error);
      })
    },
    filterCiclo(ciclo) {
      this.ciclo = ciclo;
    },
    classObject(item) {
      return this.ciclo === item;
    }
  }
}
</script>

<style>
.option.combomobile .drop li a{
  font-family: "PT Sans",serif !important;
}
</style>

<style scoped lang="scss">
@import "../../global";
.cursonewcontainer {
  margin: 0;
  padding: 0;
  font-size: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr;
  grid-column-gap: 1.875rem;
  grid-row-gap: 16px;
}

.cursonewcontainer:hover .cursos_faculdade {
  color: black;
}

.cursossection .columns {
  padding-right: 85px;
  padding-left: 85px;
}


.row .row{
  margin-left: 0;
  margin-right: 0;
}

/*223*/
.cor_fundo {
  background-color: #ffecec;
}

/*254*/
.cursossection{
  padding-bottom: 110px;
  padding-top: 95px;
  border-bottom: 2px solid #dedede;
  position: relative;
}

/*643*/
.cursonewcontainer{
  margin-top: 80px;
}

.cursonewcontainer.nomargin{
  margin-top: 0;
}

@media (max-width: 1500px) {
  .cursossection .columns {
    padding-right: 42px;
    padding-left: 42px;
  }

  .cursonewcontainer{
    margin-top: 65px;
  }

  .cursossection {
    padding-top: 65px;
  }

}

.cursonewcontainer .onlydesktop{
  display: inline-block;
}

@media (max-width: 1024px) {
  .cursonewcontainer {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .cursonewcontainer {
    grid-template-columns: repeat(1, 1fr);
  }

  .cursonewcontainer.nomargin{
    padding-top: 45px;
  }
}


/*1083*/
@media (min-width : 768px)
and (max-width : 1024px){
  /*1270*/
  .cursossection {
    padding-bottom: 70px;
    padding-top: 70px;
  }
}

.filter_mobile,.combomobile{
  display: none;
}


@media (max-width: 839px){
  .combomobile{
    display: flex;
    text-transform: uppercase;
  }

  .combomobile .drop li a{
    font-family: "PT Sans",serif !important;
  }

  .filter_mobile{
    display: flex;
    padding-top: 30px;
    padding-bottom: 0;
  }

  .cursonewcontainer{
    margin-top: 20px;
  }

  .optionslist .option {
    color: #080647;
  }

  .cursossection .columns {
    padding-right: 0;
    padding-left: 0;
  }

  .optionslist .option:first-of-type {
    padding-top: 30px;
  }

  .cursossection {
    padding-bottom: 45px;
  }


}


/*1422*/
@media (max-width: 767px) {

  /*1654*/
  .cursossection {
    padding-top: 0;
  }


}

.cursossection.artesehumanidades{
  background-color: rgba(159, 159, 218, 0.33);
}

.cursossection.cienciasexatasedaengenharia{
  background-color: rgba(135, 206, 250, 0.20);
}

.cursossection.cienciassociais{
  background-color: rgba(249, 229, 223, 0.7);;
}

.cursossection.cienciasdavida{
  background-color: rgba(254, 164, 97, 0.30);
}

.cursossection.escolasuperiordetecnologiasegestao{
  background-color: #feeac5;
}

.cursossection.escolasuperiordesaude{
  background-color: rgba(143, 243, 205, 0.35);
}

.optionslist{
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}

.optionslist.show{
  max-height: 250px;
  transition: max-height 0.25s ease-in;
}

.option{
  color:#b9b6b6;
}

.option:hover{
  cursor: pointer;
  color: #333333;
}

@media (max-width: 839px){
  .option{
    /*font-family: "Montserrat";*/
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

</style>